import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { FileUploadButton } from 'components/files/files.styled'
import { pBtn } from 'components/main.styled'  
import SpinnerSmall from 'components/SpinnerSmall'  
import { setViewConfirmModal } from 'features/modal/modalSlice'
import ExpirationTimer from 'components/utils/ExpirationTimer'

export default function EndSessionDetails({ expirationDate }) {
 
    const dispatch = useDispatch() 
    const { createQASessionStatus, endQASessionStatus } = useSelector((state) => state.qASession)

    const handleEndSession = () => {
        dispatch(setViewConfirmModal(true))
    }

    const handleUpdateSession = () => {
        
    }

    return (
        <EndSessionWrap> 
            <EndSessionButton
                onClick={handleEndSession}
                disabled={endQASessionStatus === "LOADING"}
                style={{marginBottom: '20px' }}
                width={'150px'}
                >
                { endQASessionStatus === "LOADING" ? 
                    (
                        <SpinnerSmall />
                    )
                    :
                    ( "End Session" )
                }
            </EndSessionButton>
            <FileUploadButton
                onClick={handleUpdateSession}
                disabled={createQASessionStatus === "LOADING"}
                style={{marginBottom: '20px', visibility: "hidden"}}
                width={'150px'}
                >
                { createQASessionStatus === "LOADING" ? 
                    (
                        <SpinnerSmall />
                    )
                    :
                    ( "Update" )
                }
            </FileUploadButton> 

            {
                expirationDate && 
                (
                    <ExpirationTimer expiration={expirationDate} />  
                )
            }
                
            

        </EndSessionWrap>
    )
}

const EndSessionWrap = styled.div`
    width: 100%;
    margin-top: 20px;
    gap: 20px;
    display: flex;
    flex-direction: row; 
    justify-content: space-between;
    align-items: center;
`


const EndSessionButton = styled(pBtn)`
    
    color: ${props => props.disabled ? "#8b8b8b" : "#9c3a31"};
    border: 1px solid ${props => props.disabled ? "#e1e7eb" : "#f1d4d0"};
    background-color: ${props => props.disabled ? `#f2f6f8` : '#f7ebe9'};
    border-radius: 7px;
    font-weight: 700;
    pointer-events: ${props => props.disabled ? 'none' : 'all'};

    @media (max-width: 768px) {
        align-self: center;
        justify-self: center;
    }
    &:hover{ 
        color: white;
        border: 1px solid #b73525;
        background-color: #b73525;
        transform: translateY(-1px);
    }


`
